import { columnType } from "./column-type.enum";

export interface MoosPlazaType {
    type: columnType,
    bays: number,
}


export const moosPlazaTypesModel: MoosPlazaType[] = [
    {
        type: columnType.none,
        bays: 0,
    },
    {
        type: columnType.V_P3T_S,
        bays: 3,
    },
    {
        type: columnType.V_P3T_XL,
        bays: 3,
    },
    {
        type: columnType.V_P3T_XS_M,
        bays: 3,
    },
    {
        type: columnType.V_P4T_2M,
        bays: 4,
    },
    {
        type: columnType.V_P4T_XS_S,
        bays: 4,
    },
    {
        type: columnType.V_P4T_XS_XL,
        bays: 4,
    },
    {
        type: columnType.V_P5T_SM,
        bays: 5,
    },
    {
        type: columnType.V_P5T_XL_M,
        bays: 5,
    },
    {
        type: columnType.V_P5T_XS_2M,
        bays: 5,
    },
]